import styles from './styles.module.scss';
import TooltipIcon from '../../svg/tooltip';

const Tooltip = ({text}) => (
  <div className={styles.tooltip}>
    <span className={styles.tooltip__text}>{text}</span>
    <TooltipIcon />
  </div>
);

export default Tooltip;
